import { VARIANT_UPDATED } from '../constants';

export const updateSelectedVariant = (size: any, variantId: any) => (
  dispatch
) => {
  return dispatch({
    type: VARIANT_UPDATED,
    payload: {
      size,
      variantId,
    },
  });
};
